import React, { useState, useEffect } from "react";
import APIRequest from "../../../Services/commonAPIConsumer";
import { Tooltip as ReactTooltip } from "react-tooltip";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";

export default function DLReaderStatsModal({
  isOpen,
  onClose,
  documentId,
  documentName,
  readerEmail,
  selectedLanguage
}) {
  const [statsData, setStatsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchPage, setSearchPage] = useState("");

  useEffect(() => {
    if (!isOpen || !readerEmail || !documentId) {
      setStatsData([]);
      return;
    }
    let isLoading = true;
    setLoading(true);

    const fetchStats = async () => {
      try {
        const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${documentId}`;
        const params = new URLSearchParams();
        params.append("emailAdress", readerEmail);
        params.append("IsStats", "false");
        const url = `${baseUrl}?${params.toString()}`;
        const jsonDocs = await APIRequest.GET("", url);
        if (isLoading) {
          if (jsonDocs && Array.isArray(jsonDocs)) {
            setStatsData(jsonDocs);
          } else {
            setStatsData([]);
          }
        }
      } catch (err) {
        console.error("Error fetching reader stats for DL member:", err);
        if (isLoading) setStatsData([]);
      } finally {
        if (isLoading) setLoading(false);
      }
    };

    fetchStats();
    return () => {
      isLoading = false;
    };
  }, [isOpen, readerEmail, documentId]);

  if (!isOpen || !readerEmail) return null;

  // Filter stats by search page number if user typed something
  const filteredStats = statsData.filter((stat) => {
    if (!searchPage.trim()) return true;
    return stat.pageNumber && stat.pageNumber.toString().includes(searchPage.trim());
  });

  return (
    <div
      className="modalCus documentversion-history"
      id="myModal"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1060
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="card-body pt-1 pb-0">
            {/* Header */}
            <div
              className="mb-2 mt-3 justify-content-between d-flex"
              style={{ borderBottom: "2px solid #918d8d4d" }}
            >
              <h4 className="fw-bold">
                {selectedLanguage?.LstLanguageCodes?.UI_PagesReadAllSessions}
              </h4>
              <button
                type="button" className="btn btn-outline-danger modalclose download" onClick={onClose}>
                <span className="material-icons font-20">highlight_off</span>
              </button>
            </div>

            {/* Content */}
            <div className="card-body pt-0" style={{ display: "block" }}>
              <div className="table-responsive res-card">
                <div className="track-container mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="Docnamewrap d-flex">
                      <span className="fontWeight-500">
                        {selectedLanguage?.LstLanguageCodes?.UI_DocumentName}:
                      </span>
                      <span className="ms-1">{documentName || documentId}</span>
                    </div>
                    <div className="d-flex">
                      <span className="fontWeight-500">
                        {selectedLanguage?.LstLanguageCodes?.UI_DocumentID}:
                      </span>
                      <span className="ms-1">{documentId}</span>
                    </div>
                  </div>

                  <div className="d-flex">
                    <span className="fontWeight-500">
                      {selectedLanguage?.LstLanguageCodes?.UI_ReaderEmail}:
                    </span>
                    <span className="ms-1">{readerEmail}</span>
                  </div>

                  <div className="reader-statis mt-2 d-flex justify-content-between align-items-center">
                    <div style={{ color: "#d21513" }} className="d-flex align-items-center ms-2">
                      <span className="material-icons me-1">stacked_bar_chart</span>
                      <span style={{ color: "#272d4efc" }}>
                        {selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbyPage}
                      </span>
                    </div>

                    <div
                      className="position-relative number-search"
                      style={{ maxWidth: "150px", flexShrink: 0, marginRight: "12px" }}>
                      <input
                        type="search"
                        className="form-control custom-inputBorder"
                        placeholder={`${selectedLanguage?.LstLanguageCodes?.UI_PageNumber}...`}
                        value={searchPage}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                          setSearchPage(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  {/* Table Header */}
                  <div className="d-flex border py-2 track-header">
                    <div className="flex-fill text-center w-25 text-wrap font-13 firefox-22">
                      {selectedLanguage?.LstLanguageCodes?.UI_PageNumber}
                    </div>
                    <div className="flex-fill text-center w-50 px-2 text-wrap font-13">
                      {selectedLanguage?.LstLanguageCodes?.UI_NumberOfUniqueReads}
                    </div>
                    <div className="flex-fill text-center w-25 px-2 text-wrap font-13">
                      {selectedLanguage?.LstLanguageCodes?.UI_TotalTimeViewed}
                      <ReactTooltip
                        className="totalTime-tooltip"
                        style={{ opacity: 1 }}
                        anchorId={`timeFormat_${documentId}`}
                        place="bottom"
                      >
                        <table className="tooltip-table">
                          <tbody>
                            <tr>
                              <td>
                                <div className="d-flex flex-column p-1">
                                  <p className="statistics-tooltip-text mb-0">
                                    {selectedLanguage?.LstLanguageCodes?.UI_TotalTimeFormat}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ReactTooltip>
                    </div>
                  </div>

                  {/* Table Body */}
                  <div
                    className={`track-bodyscroll ${statsData.length > 0 ? "" : "track-noBodyscroll"}`}
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {loading ? (
                      <div className="d-flex py-3 align-items-center justify-content-center">
                        <LoadingSpinner />
                      </div>
                    ) : filteredStats.length > 0 ? (
                      filteredStats.map((stat, l) => (
                        <div
                          className="d-flex border-bottom py-1 align-items-center borderrow pe-3"
                          key={l}
                        >
                          <div className="flex-fill text-center w-25 text-wrap font-12">
                            {stat.pageNumber}
                          </div>
                          <div className="flex-fill text-center w-50 px-2 text-wrap font-12">
                            {stat.totalCount !== undefined ? stat.totalCount : stat.totalReads || 0}
                          </div>
                          <div className="flex-fill text-center w-25 px-2 text-wrap font-12">
                            {String(stat.totalHours || 0).padStart(2, "0")}:
                            {String(stat.totalMinutes || 0).padStart(2, "0")}:
                            {String(stat.totalSeconds || 0).padStart(2, "0")}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="d-flex py-3 align-items-center borderrow justify-content-center">
                        <span className="material-icons" style={{ fontSize: "18px", color: "#ff9800" }}>
                          report_problem
                        </span>
                        <span className="font-13 ms-2" style={{ fontWeight: "600" }}>
                          {selectedLanguage?.LstLanguageCodes?.UI_NoRecordsFound}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
